import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';

const FAQ = () => {
  const rows = [
    ['販売事業者', '株式会社黒瀬ペットフード'],
    ['所在地', '〒720-2124 広島県福山市神辺町川南396-1'],
    ['電話番号', '0120-405-505'],
    ['メールアドレス', 'appmaster@kurose-pf.co.jp'],
    ['サービス名', '愛鳥ノート とりにてぃ'],
    ['販売価格', '月額200円（税込）'],
    ['支払方法', 'クレジットカード決済（Stripe）'],
    ['支払時期', '初回登録時および以降は毎月同日に自動更新・課金'],
    ['申込の有効期限', 'なし（自動継続）'],
    ['サービス提供時期', '決済完了後、プレミアム機能利用可能'],
    ['解約方法', 'ウェブサービス内の設定画面からご自身で手続き。解約後も当月末まで利用可'],
    ['返金について', '解約後の月額料金の返金はいたしかねます'],
    ['動作環境', '常時インターネット接続必須 、Chrome Safari 最新版、JavaScript／Cookie の有効化'],
    ['表示価格', '表示価格はすべて税込です'],
  ];

  return (
    <View style={styles.container}>
      <ScrollView contentContainerStyle={styles.scroll}>
        {/* ヘッダー行 */}
        <View style={[styles.row, styles.headerRow]}>
          <Text style={[styles.cellLabel, styles.headerText]}>項目</Text>
          <Text style={[styles.cellValue, styles.headerText]}>内容</Text>
        </View>

        {/* データ行 */}
        {rows.map(([label, value], i) => (
          <View key={i} style={styles.row}>
            <Text style={styles.cellLabel}>{label}</Text>
            <Text style={styles.cellValue}>{value}</Text>
          </View>
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  scroll: {
    padding: 16,
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#222',
    marginBottom: 8,
  },
  updated: {
    fontSize: 14,
    color: '#666',
    marginBottom: 16,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    alignItems: 'center',
  },
  headerRow: {
    borderBottomColor: '#ccc',
    borderBottomWidth: 2,
  },
  headerText: {
    fontWeight: 'bold',
    color: '#333',
  },
  cellLabel: {
    flex: 1,
    fontSize: 16,
    color: '#333',
  },
  cellValue: {
    flex: 2,
    fontSize: 16,
    color: '#555',
  },
});

export default FAQ;
